<template>
  <div>
    <CCard>
      <CCardHeader class="d-flex justify-content-between align-items-center">
        <h3 style="margin-top: 8px">{{ $i18n.t("informes.nuevo") }}</h3>
      </CCardHeader>
      <CCardBody>
        <CRow form class="form-group">
          <CCol sm="3"> Seleccionar concurso </CCol>
          <CCol sm="9">
            <CButton
              label="Seleccionar concurso"
              @click="showConcursos = true"
              color="info"
              horizontal
              >Seleccionar</CButton
            >
          </CCol>
        </CRow>
        <CCollapse :show="concursoSeleccionado != null" :duration="400">
          <CCard>
            <CCardHeader>
              <CRow v-if="concursoSeleccionado != null">
                <CCol sm="3">
                  <b>Concurso seleccionado</b>
                </CCol>
                <CCol sm="9">
                  {{ concursoSeleccionado.nombre }}
                </CCol>
              </CRow>
            </CCardHeader>
            <CCardBody>
              <CRow v-if="concursoSeleccionado != null">
                <CCol sm="3">
                  <b>Número de expediente</b>
                </CCol>
                <CCol sm="9">
                  {{ concursoSeleccionado.numeroExpediente }}
                </CCol>
              </CRow>

              <CRow
                style="margin-top: 15px"
                v-if="concursoSeleccionado != null"
              >
                <CCol sm="3">
                  <b>Cálculo de bajas</b>
                </CCol>
                <CCol sm="9">
                  <CBadge
                    :color="getBadge(concursoSeleccionado.ultimoCalculoBaja)"
                  >
                    {{ concursoSeleccionado.ultimoCalculoBaja }}
                  </CBadge>
                </CCol>
              </CRow>

              <CRow
                style="margin-top: 15px"
                v-if="concursoSeleccionado != null"
              >
                <CCol sm="3">
                  <b>Cálculo de puntos</b>
                </CCol>
                <CCol sm="9">
                  <CBadge
                    :color="getBadge(concursoSeleccionado.ultimoCalculoPuntos)"
                  >
                    {{ concursoSeleccionado.ultimoCalculoPuntos }}
                  </CBadge>
                </CCol>
              </CRow>

              <CRow
                style="margin-top: 15px"
                v-if="concursoSeleccionado != null"
              >
                <CCol sm="3">
                  <b>Estado del concurso</b>
                </CCol>
                <CCol sm="9">
                  <CBadge
                    :color="
                      getBadgeResolucion(concursoSeleccionado.estadoConcurso)
                    "
                  >
                    {{ concursoSeleccionado.estadoConcurso }}
                  </CBadge>
                </CCol>
              </CRow>
            </CCardBody>
            <CCardFooter>
              <CRow style="margin-top: 15px">
                <CCol>
                  <CSelect
                    label="Tipo de informe"
                    placeholder="Selecciona un tipo de informe"
                    :options="tiposDeInforme"
                    @change="handleTipoInforme"
                    horizontal
                  ></CSelect>
                </CCol>
                <CCol sm="12">
                  <CCollapse
                    :show="informeSeleccionado == tiposDeInforme[1]"
                    :duration="400"
                  >
                    <CInput
                      type="date"
                      @input="handleFechaEntre"
                      label="Entre"
                      placeholder="Selecciona una fecha"
                    />
                    <CInput
                      type="date"
                      @input="handleFechaHasta"
                      label="Hasta"
                      placeholder="Selecciona una fecha"
                    />
                  </CCollapse>
                </CCol>

                <CCol sm="12">
                  <CCollapse
                    :show="informeSeleccionado != null"
                    :duration="400"
                  >
                    <CButton
                      style="float: right; margin-left: 10px"
                      @click="generarExcel"
                      color="danger"
                      >Descargar Excel</CButton
                    >
                    <CButton
                      style="float: right; margin-left: 10px"
                      @click="generarCSV"
                      color="danger"
                      >Descargar CSV</CButton
                    >
                    <CButton
                      style="float: right; margin-left: 10px"
                      @click="generarPDF"
                      color="danger"
                      >Descargar PDF</CButton
                    >
                  </CCollapse>
                </CCol>
              </CRow>
            </CCardFooter>
          </CCard>
          <CButton
              @click="reiniciarConcurso"
              style="float:right"
              color="info"
              horizontal
              >Nuevo informe</CButton
            >
        </CCollapse>
      </CCardBody>
    </CCard>
    <CModal
      title="Seleccionar concurso"
      :show.sync="showConcursos"
      size="xl"
      centered
    >
      <CDataTable
        hover
        striped
        :tableFilter="{
          placeholder: 'Introducir valor',
          label: 'Buscar',
        }"
        :itemsPerPageSelect="{
          label: 'Elementos por página',
          values: [5, 10, 15, 20, 25],
        }"
        :items-per-page="5"
        :items="listaConcursos"
        :fields="camposTabla"
        sorter
        pagination
      >
        <template #acciones="{ item }">
          <td style="float: right">
            <CButton
              v-if="item.estadoConcurso != 'Cerrado'"
              color="secondary"
              @click="seleccionarConcurso(item)"
              style="display: inline-block; margin-right: 10px"
              >Seleccionar</CButton
            >
          </td>
        </template>
        <template #ultimoCalculoBaja="{ item }">
          <td>
            <CBadge :color="getBadge(item.ultimoCalculoBaja)">
              {{ item.ultimoCalculoBaja }}
            </CBadge>
          </td>
        </template>
        <template #ultimoCalculoPuntos="{ item }">
          <td>
            <CBadge :color="getBadge(item.ultimoCalculoPuntos)">
              {{ item.ultimoCalculoPuntos }}
            </CBadge>
          </td>
        </template>
        <template #estadoConcurso="{ item }">
          <td>
            <CBadge :color="getBadgeResolucion(item.estadoConcurso)">
              {{ item.estadoConcurso }}
            </CBadge>
          </td>
        </template>
      </CDataTable>

      <template #footer>
        <CButton @click="showConcursos = false" color="danger"
          >Cancelar</CButton
        >
      </template>
    </CModal>

    <CModal title="Información" :show.sync="showEvento" size="sm" centered>
      <div v-html="mensajeEvento">{{ mensajeEvento }}</div>

      <template #footer>
        <CButton @click="showEvento = false" color="danger">Aceptar</CButton>
      </template>
    </CModal>
  </div>
</template>

<style scoped>
</style>

<script>
import Cookies from "js-cookie";
import { getAllConcursos, getInformeConcurso } from "../../requests/concursos";
import { logOut } from "../../utils/authUtils";
import CustomExport from "../../utils/CustomExport";
import { generarInformeExcel } from "../../utils/exportExcel";
import { exportToCsv } from "../../utils/exportCsv";
import { exportToPdf } from "../../utils/exportPdf";

export default {
  name: "ConsultarLotes",
  components: {
    CustomExport,
  },
  created() {},
  mounted() {
    this.cargarConcursos();
  },
  data() {
    return {
      tiposDeInforme: [
        "Informe de clasificación",
        "Informe por fases",
        "Informe final",
      ], //lista de lotes
      showEvento: false,
      mensajeEvento: "",
      informeSeleccionado: null, //tipo de informe seleccionado
      listaConcursos: [], //lista de concursos para elegir
      showConcursos: false, //muestra los concursos para seleccionar uno
      fechaEntre: "",
      fechaHasta: "",
      entreFechaText: "", //texto con el rango de las fechas para mostrar en el nombre de fichero y titulo del excel
      hastaFechaText: "", //texto con el rango de las fechas
      listaDatosInforme: [], //lista para el informe por clasificacion
      listaDatosGanadores: [], //lista para el informe final
      concursoSeleccionado: null, //concurso elegido
      concursoSeleccionadoDetalles: {}, //info completa del concurso elegido
      camposTabla: [
        { key: "nombre", field: "Nombre", label: "Nombre" },
        {
          key: "numeroExpediente",
          field: "Número de expediente",
          label: "Número de expediente",
        },
        {
          key: "ultimoCalculoBaja",
          field: "Cálculo de baja",
          label: "Cálculo de baja",
        },
        {
          key: "ultimoCalculoPuntos",
          field: "Cálculo de puntos",
          label: "Cálculo de puntos",
        },
        {
          key: "estadoConcurso",
          field: "Estado del concurso",
          label: "Estado del concurso",
        },
        { key: "acciones", label: "" },
      ],
      camposOferta: [
        { key: "numeroExpediente", field: "Expediente", label: "Expediente" },
        { key: "numeroLote", field: "Lote", label: "Lote" },
        { key: "precioDiaSinIVALicitacion", field: "Precio dia licitación", label: "Precio dia licitación" },
        { key: "estadoLote", field: "Estado del lote", label: "Estado del lote" },
        {
          key: "ordenPreferencia",
          field: "Orden Preferencia",
          label: "Orden Preferencia",
        },
        { key: "puestoConcurso", field: "Puesto", label: "Puesto" },        
        { key: "nombreLicitador", field: "Nombre", label: "Nombre" },
        { key: "dninifLicitador", field: "DNI / CIF", label: "DNI / CIF" },
        { key: "numVehiculosOfertados", field: "Vehiculos Ofertados", label: "Vehiculos Ofertados" },
        { key: "puntos", field: "Puntos", label: "Puntos" },
        { key: "baja", field: "Baja", label: "Baja" },
        { key: "excluido", field: "Excluido", label: "Excluido" },
        { key: "descripcionEstado", field: "Estado del lote ofertado", label: "Estado del lote ofertado" },
        {
          key: "precioDiaSinIVA",
          field: "Precio dia",
          label: "Precio dia",
        },
        {
          key: "plazasTotales",
          field: "Plazas totales",
          label: "Plazas totales",
        },
        {
          key: "descripcionAntiguedad",
          field: "Antiguedad",
          label: "Antiguedad",
        },
        {
          key: "descripcionEmision",
          field: "Emisiones",
          label: "Emisiones",
        },
        {
          key: "estabilidadLaboral",
          field: "Estabilidad laboral",
          label: "Estabilidad laboral",
        },
        {
          key: "accesibilidad",
          field: "Accesibilidad",
          label: "Accesibilidad",
        },
        {
          key: "cumpleUNE26494",
          field: "Acredita oficialmente adaptación",
          label: "Acredita oficialmente adaptación",
        },
       // {
        //  key: "vehiculoDisponible",
        //  field: "Disponibilidad vehículo",
        //  label: "Disponibilidad vehículo",
        //},
        {
          key: "descripcionContinuidad",
          field: "Compromiso Continuidad",
          label: "Compromiso Continuidad",
        }
        /*,
        {
          key: "distanciaTallerCochera",
          field: "Distancia del taller a la cochera",
          label: "Distancia del taller a la cochera",
        },*/
      ],
    };
  },
  methods: {
    cargarConcursos() {
      getAllConcursos()
        .then((res) => {
          this.listaConcursos = [];
          res.data.forEach((element) => {
            this.listaConcursos.push({
              nombre: element.nombre,
              idConcurso: element.id,
              numeroExpediente: element.numeroExpediente,
              ultimoCalculoBaja: element.ultimoCalculoBaja
                ? "Calculado"
                : "Pendiente",
              ultimoCalculoPuntos: element.ultimoCalculoPuntos
                ? "Calculado"
                : "Pendiente",
              estadoConcurso: element.estadoConcurso,
            });
          });
        })
        .catch((error) => {
          if (error.response.status == 403 || error.response.status == 401)
            logOut(this.$router);
        });
    },
    seleccionarConcurso(concurso) {
      this.concursoSeleccionado = concurso;
      getInformeConcurso(this.concursoSeleccionado.idConcurso)
        .then((res) => {
          this.concursoSeleccionadoDetalles = res.data;
          this.generarInformeClasificación();
        })
        .catch((error) => {
          this.showEvento = true;
          this.mensajeEvento =
            "No se han podido cargar la información del concurso. <br> Causa: <b>" +
            error.response.data.error +
            "</b>.";
        });
      this.showConcursos = false;
    },
    generarInformeClasificación() {
      this.listaDatosInforme = [];
      this.listaDatosGanadores = [];
    
      //console.log(this.concursoSeleccionadoDetalles);
      //console.log(this.concursoSeleccionadoDetalles.criteriosEvaluacion);
      // console.log(this.concursoSeleccionadoDetalles);
      
      this.concursoSeleccionadoDetalles.expedientes.forEach((expediente) => {
        let numeroExpediente = expediente.nombre;
       
        expediente.lotes.forEach((lote) => {
          let numeroLote = lote.numero;
          let estadoLote = lote.descripcionEstadoLote;
          let fechaAdjudicacion = lote.fechaAdjudicacion;
          let precioDiaSinIVALicitacion = Intl.NumberFormat("es-ES",{minimumFractionDigits: 0,maximumFractionDigits: 2}).format(lote.precioDiaSinIVA)+" €";
                    
          lote.lotesOfertados.sort(function (a, b) {
            //ordena la lista de ofertas de mas a menos puntlos
                            
              if (a.puestoConcurso && b.puestoConcurso)
              return a.puestoConcurso - b.puestoConcurso;
                         
              if (a.puestoConcurso) return b.puestoConcurso - a.puestoConcurso;

              if (b.puestoConcurso) return b.puestoConcurso - a.puestoConcurso;

              return a.puestoConcurso - b.puestoConcurso;
              
          });
          
          if (lote.lotesOfertados.length == 0) {
            let lote = {};
            this.camposOferta.forEach(campo => {
              lote[campo.key] = "";
            })
            this.listaDatosGanadores.push({...lote,
              estadoLote: estadoLote,
              numeroLote: numeroLote,
              numeroExpediente: numeroExpediente,
            });
            this.listaDatosInforme.push({...lote,
              estadoLote: estadoLote,
              numeroLote: numeroLote,
              numeroExpediente: numeroExpediente,
            });
          }
          let desiertoAñadido = false; //que no meta mas de una oferta en un lote desierto

          lote.lotesOfertados.forEach((oferta) => {           
            oferta["numeroExpediente"] = numeroExpediente;
            oferta["numeroLote"] = numeroLote;
            oferta["precioDiaSinIVALicitacion"] = precioDiaSinIVALicitacion;            
            oferta["estadoLote"] = estadoLote;
            oferta["excluido"] = oferta["excluido"] == 0 ? "No" : "Si";
           
           oferta["estabilidadLaboral"] = oferta["estabilidadLaboral"] == 0 ? "No" : "Si";
            oferta["accesibilidad"] = oferta["accesibilidad"] == 0 ? "No" : "Si";
            oferta["cumpleUNE26494"] =  oferta["cumpleUNE26494"] == null ? "" : ( oferta["cumpleUNE26494"] == 0 ? "No" : "Si");

            oferta["vehiculoDisponible"] = oferta["vehiculoDisponible"] ? oferta["vehiculoDisponible"] : "-";
            oferta["puestoConcurso"] = oferta["puestoConcurso"] ? oferta["puestoConcurso"] : "Sin puesto";            
            oferta["plazasTotales"] = oferta["plazasTotales"] ? oferta["plazasTotales"] : "-";
       
          //MODIFICAMOS LOS VALORES DE LOS NUMEROS PARA QUE SALGA EN FORMATO MONEDA
          
          // oferta["IVADiario"] = Intl.NumberFormat("es-ES",{style: "currency", currency: "EUR"}).format(oferta["IVADiario"]);
          // oferta["precioDiaSinIVA"] = Intl.NumberFormat("es-ES",{style: "currency", currency: "EUR"}).format(oferta["precioDiaSinIVA"]);
          // oferta["precioDiaConIVA"] = Intl.NumberFormat("es-ES",{style: "currency", currency: "EUR"}).format(oferta["precioDiaConIVA"]);
           
           oferta["precioDiaSinIVA"] = Intl.NumberFormat("es-ES",{minimumFractionDigits: 0,maximumFractionDigits: 2}).format(oferta["precioDiaSinIVA"])+" €";
           oferta["puntos"]=Intl.NumberFormat("es-ES",{minimumFractionDigits: 0,maximumFractionDigits: 2}).format(oferta["puntos"]);

            if ( //si no es desierto o desistido y el lote está en adjudicado
              oferta["descripcionEstado"] == 'Adjudicado' &&
              estadoLote != "Desierto" &&
              estadoLote != "Desistido o renunciado"
            ) {
              oferta["fechaAdjudicacion"] = fechaAdjudicacion;
              this.listaDatosGanadores.push(oferta);
              desiertoAñadido = false;
            } else if (
              estadoLote == "Desierto" ||
              estadoLote == "Desistido o renunciado"
            ) {
              if (!desiertoAñadido) {
                //console.log(oferta);
                desiertoAñadido = true;
                Object.keys(oferta).forEach(key => {
                  if(key != "numeroExpediente" && key != "numeroLote" && key != "estadoLote"){
                    oferta[key] = "";
                  }
                })
                this.listaDatosGanadores.push(oferta);
              }
            }
        

          this.listaDatosInforme.push(oferta);
          });
        });
      });

 
 //BORRAMOS LOS CAMPOS QUE NOS NOS INTERESA EN FUNCION DEL TIPO DE CONCURSO
 
    //criterios <10p
    var x_criterio_accesibilidad = this.concursoSeleccionadoDetalles.criteriosEvaluacion.find( criterio => criterio.nombreCriterio === 'Accesibilidad' );
    if(x_criterio_accesibilidad === undefined)
    {this.camposOferta=this.camposOferta.filter(field => field.key != "accesibilidad");}

    var x_criterio_antiguedad = this.concursoSeleccionadoDetalles.criteriosEvaluacion.find( criterio => criterio.nombreCriterio === 'Antigüedad' );
    if(x_criterio_antiguedad === undefined)
    {this.camposOferta=this.camposOferta.filter(field => field.key != "descripcionAntiguedad");}

    var x_criterio_emision = this.concursoSeleccionadoDetalles.criteriosEvaluacion.find( criterio => criterio.nombreCriterio === 'Niveles Emisión' );
    if(x_criterio_emision === undefined)
    {this.camposOferta=this.camposOferta.filter(field => field.key != "descripcionEmision");}

  //criterios >9p
  var x_criterio_estabilidadLaboral = this.concursoSeleccionadoDetalles.criteriosEvaluacion.find( criterio => criterio.nombreCriterio === 'Estabilidad' );
  if(x_criterio_estabilidadLaboral === undefined)
  {this.camposOferta=this.camposOferta.filter(field => field.key != "estabilidadLaboral");}

 
  var x_criterio_descripcionContinuidad = this.concursoSeleccionadoDetalles.criteriosEvaluacion.find( criterio => criterio.nombreCriterio === 'Compromiso Continuidad' );
  if(x_criterio_descripcionContinuidad === undefined)
{this.camposOferta=this.camposOferta.filter(field => field.key != "descripcionContinuidad");}

var x_criterio_plazasTotales = this.concursoSeleccionadoDetalles.criteriosEvaluacion.find( criterio => criterio.nombreCriterio === 'Plazas Complementarias' );
if(x_criterio_plazasTotales === undefined)
  {this.camposOferta=this.camposOferta.filter(field => field.key != "plazasTotales");}

 
    },
    getBadge(idEstado) {
      switch (idEstado) {
        case "Pendiente":
          return "warning";
        case "Calculado":
          return "success";
      }
    },
    handleTipoInforme(event) {
      this.informeSeleccionado = event.target.value;
    },
    handleFechaEntre(value) {
      this.fechaEntre = new Date(value);
      this.entreFechaText = value;
    },
    handleFechaHasta(value) {
      this.fechaHasta = new Date(value);
      this.fechaHasta.setHours(23);
      this.hastaFechaText = value;
    },
    filtrarListaPorFechas() {
      let listaTemp = [];
      this.listaDatosGanadores.forEach((oferta) => {
        let numLote = oferta.numeroLote;
        let estadoLote = oferta.estadoLote;
        if (
          oferta.fechaAdjudicacion &&
          !(
            oferta.estadoLote == "Desierto" ||
            oferta.estadoLote == "Desistido o renunciado"
          )
        ) {
          let fechaOferta = new Date(oferta.fechaAdjudicacion);
          //console.log(fechaOferta);
          if (
            fechaOferta &&
            fechaOferta > this.fechaEntre &&
            fechaOferta < this.fechaHasta
          )
            listaTemp.push(oferta);
        }
      });
      return listaTemp;
    },
    generarExcel() {     
     switch (this.informeSeleccionado) {
        case this.tiposDeInforme[0]:
         generarInformeExcel(
            this.listaDatosInforme,
            this.camposOferta,
            "Clasificación - " + this.concursoSeleccionado.nombre
          );
          break;
        case this.tiposDeInforme[1]:
          generarInformeExcel(
            this.filtrarListaPorFechas(),
            this.camposOferta,
            "Clasificación " +
              this.entreFechaText +
              "-" +
              this.hastaFechaText +
              " " +
              this.concursoSeleccionado.nombre
          );
          break;
        case this.tiposDeInforme[2]:
          generarInformeExcel(
            this.listaDatosGanadores,
            this.camposOferta,
            "Clasificación final - " + this.concursoSeleccionado.nombre
          );
          break;
      }
    },
    generarCSV() {
      switch (this.informeSeleccionado) {
        case this.tiposDeInforme[0]:
          exportToCsv(
            this.listaDatosInforme,
            "Clasificación - " + this.concursoSeleccionado.nombre,
            this.camposOferta
          );
          break;
        case this.tiposDeInforme[1]:
          exportToCsv(
            this.filtrarListaPorFechas(),
            "Clasificación " +
              this.entreFechaText +
              "-" +
              this.hastaFechaText +
              " " +
              this.concursoSeleccionado.nombre,
            this.camposOferta
          );
          break;
        case this.tiposDeInforme[2]:
          exportToCsv(
            this.listaDatosGanadores,
            "Clasificación final - " + this.concursoSeleccionado.nombre,
            this.camposOferta
          );
          break;
      }
    },
    generarPDF() {
      //console.log(this.listaDatosInforme)
      let listaDatosInformesTemp = []; //hago una copia del array que se basa el excel para introducir una fila a mano en el pdf
      let listaDatosGanadoresTemp = []; //recorro las listas para introducir una oferta vacia para que haga un salto
      let currentLote = -1;

      switch (this.informeSeleccionado) {
        case this.tiposDeInforme[0]:
          this.listaDatosInforme.forEach((oferta, index) => {
            if (index == 0) currentLote = oferta.numeroLote;

            if (oferta.numeroLote != currentLote && index > 0) {
              currentLote = oferta.numeroLote;
              listaDatosInformesTemp.push({}); //añade un elemento vacio para el salto de fila en el pdf
            }
            listaDatosInformesTemp.push(oferta);
          });
          exportToPdf(
            listaDatosInformesTemp,
            this.camposOferta,
            "Clasificación - " + this.concursoSeleccionado.nombre
          );
          break;
        case this.tiposDeInforme[1]:
          this.filtrarListaPorFechas().forEach((oferta, index) => {
            if (index == 0) currentLote = oferta.numeroLote;
            if (oferta.numeroLote != currentLote && index > 0) {
              currentLote = oferta.numeroLote;
              listaDatosGanadoresTemp.push({}); //añade un elemento vacio para el salto de fila en el pdf
            }

            listaDatosGanadoresTemp.push(oferta);
          });

          exportToPdf(
            listaDatosGanadoresTemp,
            this.camposOferta,
            "Clasificación " +
              this.entreFechaText +
              "-" +
              this.hastaFechaText +
              " " +
              this.concursoSeleccionado.nombre
          );
          break;
        case this.tiposDeInforme[2]:
          this.listaDatosGanadores.forEach((oferta, index) => {
            if (index == 0) {
              currentLote = oferta.numeroLote;
              listaDatosGanadoresTemp.push(oferta);
            }
            if (oferta.numeroLote != currentLote && index > 0) {
              currentLote = oferta.numeroLote;
              listaDatosGanadoresTemp.push({}); //añade un elemento vacio para el salto de fila en el pdf
              listaDatosGanadoresTemp.push(oferta);
            }

          });

          exportToPdf(
            listaDatosGanadoresTemp,
            this.camposOferta,
            "Clasificación final - " + this.concursoSeleccionado.nombre
          );
          break;
      }
    },
    reiniciarConcurso(){
      this.concursoSeleccionado = null; 
      this.concursoSeleccionadoDetalles = null
    },
    getBadgeResolucion(idEstado) {
      //console.log(idEstado);
      switch (idEstado) {
        case "Cerrado":
          return "danger";
        case "Pendiente":
          return "warning";
        case "Abierto":
          return "info";
        case "En Resolución":
          return "success";
      }
    },
  },
  beforeDestroy() {},
};
</script>
